import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const customPreset = definePreset(Aura, {
  components: {
    button: {
      borderRadius: '50%', // ou '1rem', '0.75rem', etc.
    }
  },
  semantic: {
    primary: {
      50: '#f2f9f7',
      100: '#d8efea',
      200: '#b1dfd4',
      300: '#84c6bc',
      400: '#5ba89b',
      500: '#3f8d85',
      600: '#2a5b57',
      700: '#254a47',
      800: '#1f3d3a',
      900: '#0f2423',
      950: '#0a1817',
    },
    colorScheme: {
      light: {
        formField: {
          background: '#ffffff',
        },
        surface: {
          0: '#ffffff',
        },
        primary: {
          color: '#84c6bc',
          contrastColor: '#0f2423',
          inverseColor: '#ffffff',
          hoverColor: '#3f8d85',
          activeColor: '#254a47',
        },
        highlight: {
          background: '#3f8d85',
          focusBackground: '#2a5b57',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '#d8efea',
          contrastColor: '#0f2423',
          inverseColor: '#0f2423',
          hoverColor: '#b1dfd4',
          activeColor: '#84c6bc',
        },
        highlight: {
          background: 'rgba(216, 239, 234, .16)',
          focusBackground: 'rgba(216, 239, 234, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
});

export default customPreset;
